import { ErrorMessages, Rule } from '@ubud/form';
import { Validators } from '@angular/forms';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
export class RegisterInstitutionRule extends Rule {
    public get errorMessages(): ErrorMessages {
        return {
            institution_name: {
                required: (params: any) => 'Nama lembaga tidak boleh kosong',
            },
            institution_type: {
                required: (params: any) => 'Tipe lembaga tidak boleh kosong',
            },
            owner: {
                required: (params: any) => 'Nama pimpinan tidak boleh kosong',
            },
            since: {
                required: (params: any) => 'Tahun berdiri tidak boleh kosong',
            },
            institution_email: {
                required: (params: any) => 'Email lembaga tidak boleh kosong',
            },
            postal_code: {
                required: (params: any) => 'Kode pos tidak boleh kosong',
            },
            address: {
                required: (params: any) => 'Alamat tidak boleh kosong',
            },
            phone: {
                required: (params: any) => 'No. telepon tidak boleh kosong',
            },
        };
    }

    public get institutionName(): Function {
        return Validators.required;
    }

    public get institutionType(): Function {
        return Validators.required;
    }

    public get owner(): Function {
        return Validators.required;
    }

    public get since(): Function {
        return Validators.required;
    }

    public get institutionEmail(): Function {
        return Validators.required;
    }

    public get postalCode(): Function {
        return Validators.required;
    }

    public get address(): Function {
        return Validators.required;
    }

    public get phone(): Function {
        return Validators.required;
    }

    public getFormControls(): { [p: string]: any } {
        return {
            institution_name: ['', this.institutionName],
            institution_type: [''],
            owner: ['', this.owner],
            since: ['', this.since],
            institution_email: ['', this.institutionEmail],
            postal_code: ['', this.postalCode],
            address: ['', this.address],
            phone: ['', this.phone],
            fax: [],
            website: [],
            register_type: [],
            location_long: [''],
            location_lat: [''],
            wlkp_code: [''],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/rules/register-institution.rule.ts